import * as React from 'react'
import { useSelector } from 'react-redux'
// eslint-disable-next-line
import { useMap } from '@vis.gl/react-google-maps/dist/index.umd.js'

export default function VehicleRouteTwo() {
  return <PolylineOverlay />
}

const PolylineOverlay = () => {
  const map = useMap()
  const { selectedRoute, routeShape } = useSelector((s) => s.maps)
  const [polyline, setPolyline] = React.useState(null)

  React.useEffect(() => {
    if (!map || typeof window === 'undefined' || !window.google) return

    if (selectedRoute && routeShape.length > 0 && !polyline) {
      createPolyline(map, routeShape, selectedRoute.route_color)
    } else if ((!selectedRoute || routeShape.length === 0) && polyline) {
      polyline.setMap(null)
      setPolyline(null)
    } else if (selectedRoute && polyline) {
      const path = routeShape
        .flatMap((route) =>
          route.geometry.coordinates.map(([lng, lat]) => ({
            lat,
            lng,
          })),
        )
        .map((coord) => new window.google.maps.LatLng(coord.lat, coord.lng))

      polyline.setPath(path)
      polyline.setOptions({
        strokeColor: selectedRoute.route_color || '#cc0033',
      })
    }
  }, [map, routeShape, selectedRoute, polyline])
  // eslint-disable-next-line
  const createPolyline = React.useCallback((map, shape, color) => {
    const path = shape
      .flatMap((route) =>
        route.geometry.coordinates.map(([lng, lat]) => ({
          lat,
          lng,
        })),
      )
      .map((coord) => new window.google.maps.LatLng(coord.lat, coord.lng))

    const newPolyline = new window.google.maps.Polyline({
      path,
      strokeColor: color || '#cc0033',
      strokeOpacity: 0.8,
      fillOpacity: 0.35,
      strokeWeight: 3,
      editable: false,
      zIndex: 1,
      map,
    })

    setPolyline(newPolyline)
  }, [])

  return null
}
